import CTA from "./CTA";
import type { Props } from "./types";

export default function Counter({
	count = 0,
	...props
}: Props & { count?: number }) {
	const counter = count > 99 ? "hundreds" : count > 9 ? "tens" : "ones";
	return <CTA counter={counter} colors="teal" {...props} />;
}
